<script lang="ts" setup>
import { storeToRefs } from 'pinia'
import AppHeader from '@/components/app/AppHeader.vue'
import { RHDHVSnackbar } from '@rhdhv/vue-component-library'

import { useDjangoAuthStore } from '@/stores/authDjango'

const { user } = storeToRefs(useDjangoAuthStore())
const appbar = ref(null)
const appHeaderHeight = ref<number>(0)
provide('appHeaderHeight', appHeaderHeight)

watch(
  () => user.value,
  async (val) => {
    if (val) {
      await nextTick()
      appHeaderHeight.value = appbar.value?.$el?.offsetHeight || 0
    }
  }
)
</script>

<template>
  <v-app>
    <AppHeader v-if="user" ref="appbar"></AppHeader>
    <v-main>
      <router-view />
      <RHDHVSnackbar
        style="z-index: 3000"
        :excluded-http-methods="['GET', 'OPTIONS']"
      ></RHDHVSnackbar>
    </v-main>
  </v-app>
</template>

<style lang="scss">
@use '/src/scss/settings.scss';
</style>
